(function () {
    // Configuration
    const TARGET_SELECTOR = '.rebuy-cart__flyout';
    const BADGE_URL = 'https://cdn.shopify.com/s/files/1/0536/1978/5913/files/guarantee-badge.png?v=1765920794';
    const COMPONENT_ID = 'ab-test-guarantee-banner';

    // Function to mount the component
    const mountComponent = (targetNode) => {
        // Safety Check: Prevent duplicate injection
        if (document.getElementById(COMPONENT_ID)) {
            console.log('AB Test: Banner already injected.');
            return;
        }

        // 2. Inject CSS Styles
        const style = document.createElement('style');
        style.innerHTML = `
            #${COMPONENT_ID} {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 20px;
                gap: 16px;
                width: 100%;
                box-sizing: border-box;
                background: #EEEEEE;
                font-family: 'Nebulas', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                text-align: left;
            }

            #${COMPONENT_ID} .ab-badge-img {
                width: 56px;
                height: 56px;
                flex: none;
                object-fit: contain;
            }

            #${COMPONENT_ID} .ab-text-wrapper {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 4px;
                flex-grow: 1;
            }

            #${COMPONENT_ID} .ab-title {
                font-weight: 500;
                font-size: 16px;
                line-height: 120%;
                letter-spacing: 0.8px;
                color: #101B13;
                margin: 0;
            }

            #${COMPONENT_ID} .ab-subtitle {
                font-weight: 400;
                font-size: 10px;
                line-height: 140%;
                letter-spacing: 0.3px;
                color: #939393;
                margin: 0;
            }

            @media screen and (min-width: 1023px){
                #${COMPONENT_ID} .ab-subtitle {
                font-size: 12px;
                }
            }
        `;
        document.head.appendChild(style);

        // 3. Create HTML Structure
        const container = document.createElement('div');
        container.id = COMPONENT_ID;

        container.innerHTML = `
            <img src="${BADGE_URL}" alt="30 Days Guarantee" class="ab-badge-img">
            <div class="ab-text-wrapper">
                <h4 class="ab-title">30 Day Money-Back Guarantee</h4>
                <p class="ab-subtitle">If you don’t love the product you received, return it for a refund.</p>
            </div>
        `;

        // 4. Append to the target location
        targetNode.append(container);
        console.log('AB Test: Guarantee banner injected successfully.');
    };

    // --- Main Execution Logic ---

    // Check if element exists immediately
    const existingNode = document.querySelector(TARGET_SELECTOR);

    if (existingNode) {
        mountComponent(existingNode);
    } else {
        console.log(`AB Test: Waiting for '${TARGET_SELECTOR}' to appear...`);

        // Initialize MutationObserver
        const observer = new MutationObserver((mutations, obs) => {
            const targetNode = document.querySelector(TARGET_SELECTOR);
            if (targetNode) {
                mountComponent(targetNode);
                obs.disconnect(); // Stop observing once the element is found and injected
            }
        });

        // Start observing the document body for added nodes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

})();